import React, {useState} from 'react';

//import icons
import { IoMdClose } from 'react-icons/io';
import { RiMenuFill } from 'react-icons/ri';

//import link
import { Link, useLocation } from 'react-router-dom';

//import motion
import { motion } from 'framer-motion';
import {ImInstagram} from 'react-icons/im';

// menu variants
const menuVariants = {
  hidden : {
    x: '100%'
  },
  show: {
    x: '0%',
    transition: {
      ease: [0.6, 0.01, -0.05, 0.9]
    },
  },
};

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/hotels', label: 'Hotels' },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

const MobileNav = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const location = useLocation();

  const isActive = (to) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);

  return (
    <nav className='text-primary md:hidden'>
      {/* nav open button */}
      <div onClick={()=> setOpenMenu(true)} className='text-3xl cursor-pointer'>
        <RiMenuFill />
      </div>
      {/* menu */}
      <motion.div 
        variants={menuVariants} 
        initial='hidden'
        animate={openMenu ? 'show' : ''}
        className='bg-white shadow-2xl w-full absolute top-0 
      right-0 max-w-screen h-screen z-20'>
        {/* icon */}
        <div onClick={()=> setOpenMenu(false)} className='text-4xl  right-10 top-10 absolute z-30
        text-primary cursor-pointer'>
          <IoMdClose />
        </div>
        <ul className='h-full flex flex-col justify-center 
        items-center gap-y-8 font-secondary'>
          {NAV_ITEMS.map((item) => (
            <li key={item.to} onClick={()=> setOpenMenu(false)}>
              <Link
                to={item.to}
                className={`text-xl tracking-widest uppercase transition hover:text-primary ${
                  isActive(item.to)
                    ? 'text-primary font-bold underline underline-offset-4'
                    : 'text-[#888]'
                }`}
              >
                {item.label}
              </Link>
            </li>
          ))}
          <li className='pt-10'>
            <a href='https://www.instagram.com/emmatysinger_photos/' target='_blank' rel='noreferrer'>
              <ImInstagram />
            </a>
          </li>
        </ul>
      </motion.div>
      
    </nav>)
};

export default MobileNav;
